export default __webpack_public_path__ + "static/Vumography-BG6-c40e4d06ad8b6cdc13999b29256c4c32.webp";